import styled from "styled-components";
import { InputNumber, Drawer, Row, Col } from "antd";
import { RATypography } from "../customs/Typography";
import { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import { SvgProfile, SvgAddPassenger, SvgRemovePassenger } from "@/assets/icons";
import { RAButtonPrimary } from "../customs";
import { IconCloseSvg } from "../svgs";

export const RAInputPassenger = ({
	value = 1,
	title,
	min = 0,
	onChange,
	"data-testid": dataTestId = null,
	...props
}) => {
	const [open, setOpen] = useState(false);
	return (
		<div>
			{title && (
				<WrapperTitle>
					<RATypography color="#595959" variant="sub-heading4">
						{title}
					</RATypography>
				</WrapperTitle>
			)}

			<StyledInput
				data-testid={dataTestId}
				{...props}
				prefix={<SvgProfile color="#595959" />}
				value={value}
				readOnly="readonly"
				placeholder="Passengers"
				formatter={(val) => {
					if (!val) return "";
					return `${val} Passengers`;
				}}
				onClick={() => setOpen(true)}
			/>
			<Drawer
				title={<InputPassengerHeader onClose={() => setOpen(false)} />}
				rootClassName="passenger-drawer"
				placement={"bottom"}
				closable={false}
				onClose={() => setOpen(false)}
				open={open}
				height={230}
				getPopupContainer={(trigger) => trigger.parentElement}
			>
				<InputPassengerBody
					onApply={(val) => {
						onChange?.(val);
						setOpen(false);
					}}
					initialValue={value}
					min={min}
				/>
			</Drawer>
		</div>
	);
};

const InputPassengerHeader = ({ onClose }) => {
	return (
		<Row align="middle" justify="center">
			<RATypography variant="sub-heading3">Select Number of Passengers</RATypography>
			<CloseIcon onClick={() => onClose?.()}>
				<IconCloseSvg />
			</CloseIcon>
		</Row>
	);
};

const InputPassengerBody = ({ onApply, initialValue = 0, min = 0 }) => {
	const [tempValue, setTempValue] = useState(1);
	useEffect(() => {
		if (initialValue > 0) {
			setTempValue(initialValue);
		} else {
			setTempValue(min);
		}
	}, [initialValue]);
	return (
		<PassengerDrawerContainer>
			<Row align="middle" justify="space-between" style={{ flexGrow: 1 }}>
				<Col>
					<RATypography variant="sub-heading4">Passengers</RATypography>
				</Col>
				<Col>
					<Row align="middle" gutter={8}>
						<Col className="change-passenger-button">
							<Row align="middle">
								<SvgRemovePassenger
									onClick={() => tempValue > min && setTempValue((prev) => prev - 1)}
								/>
							</Row>
						</Col>
						<Col style={{ width: 44, textAlign: "center" }}>
							<RATypography variant="body2">{tempValue}</RATypography>
						</Col>
						<Col className="change-passenger-button">
							<Row align="middle">
								<SvgAddPassenger onClick={() => setTempValue((prev) => prev + 1)} />
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row>
				<RAButtonPrimary
					title="APPLY"
					onClick={() => {
						onApply?.(tempValue);
					}}
					width="100%"
				/>
			</Row>
		</PassengerDrawerContainer>
	);
};

const StyledInput = styled(InputNumber)``;
const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;

const PassengerDrawerContainer = styled.div`
	padding: 19px 19px 40px 19px;
	width: 100%;
	display: flex;
	flex-direction: column;
	overscroll-behavior: contain;
`;

const CloseIcon = styled.div`
	position: absolute;
	right: 12px;
	top: 12px;
	padding: 4px;
	cursor: pointer;
`;
